const set = (state, action) => {
    return {
        ...state, cartWorkingItem: {...state.cartWorkingItem, sleeve: action.payload}
    }
}

export default {set}